"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Popover = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _Popper = _interopRequireDefault(require("../Popper"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// Must export raw component (not wrapped in click-outside) for react-docgen to work
var Popover =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Popover, _React$Component);

  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popover).call(this, props));
    _this.state = {
      transitionedIn: false,
      anchorEl: null
    };
    _this.targetRef = _react["default"].createRef();
    _this.openPopper = _this.openPopper.bind(_assertThisInitialized(_this));
    _this.closePopper = _this.closePopper.bind(_assertThisInitialized(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var open = this.props.open;
      if (open) this.openPopper();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var open = this.props.open;

      if (prevProps.open !== open) {
        if (open) this.openPopper();else this.closePopper();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.transitionTimeout);
    }
  }, {
    key: "openPopper",
    value: function openPopper() {
      this.setState({
        transitionedIn: true,
        anchorEl: this.targetRef.current
      });
    }
  }, {
    key: "closePopper",
    value: function closePopper() {
      var _this2 = this;

      this.setState({
        transitionedIn: false
      }, function () {
        _this2.transitionTimeout = setTimeout(function () {
          _this2.setState(function (state) {
            if (state.transitionedIn) return null;
            return {
              anchorEl: null
            };
          });
        }, 500);
      });
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside() {
      var anchorEl = this.state.anchorEl;
      var onRequestClose = this.props.onRequestClose;
      if (anchorEl) onRequestClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          transitionedIn = _this$state.transitionedIn,
          anchorEl = _this$state.anchorEl;

      var _this$props = this.props,
          classes = _this$props.classes,
          target = _this$props.target,
          open = _this$props.open,
          onRequestClose = _this$props.onRequestClose,
          children = _this$props.children,
          placement = _this$props.placement,
          hideArrow = _this$props.hideArrow,
          StyledPopper = _this$props.StyledPopper,
          popperProps = _this$props.popperProps,
          uncontained = _this$props.uncontained,
          disableTransitions = _this$props.disableTransitions,
          eventTypes = _this$props.eventTypes,
          outsideClickIgnoreClass = _this$props.outsideClickIgnoreClass,
          preventDefault = _this$props.preventDefault,
          stopPropagation = _this$props.stopPropagation,
          enableOnClickOutside = _this$props.enableOnClickOutside,
          disableOnClickOutside = _this$props.disableOnClickOutside,
          props = _objectWithoutProperties(_this$props, ["classes", "target", "open", "onRequestClose", "children", "placement", "hideArrow", "StyledPopper", "popperProps", "uncontained", "disableTransitions", "eventTypes", "outsideClickIgnoreClass", "preventDefault", "stopPropagation", "enableOnClickOutside", "disableOnClickOutside"]);

      var PopperComponent = StyledPopper || _Popper["default"];
      var popperContainerClassname = (0, _classnames["default"])(classes.popperContainer, transitionedIn ? classes.transitionIn : classes.transitionOut);
      return _react["default"].createElement("div", _extends({
        className: classes.root
      }, props), _react["default"].createElement("div", {
        className: classes.targetContainer,
        ref: this.targetRef
      }, target), _react["default"].createElement("div", {
        className: popperContainerClassname
      }, _react["default"].createElement(PopperComponent, _extends({
        anchorEl: anchorEl,
        open: !!anchorEl,
        placement: placement,
        hideArrow: hideArrow
      }, popperProps), children)));
    }
  }]);

  return Popover;
}(_react["default"].Component);

exports.Popover = Popover;
Popover.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Children will populate content of popper */
  children: _propTypes["default"].node,

  /** Target node from which the popper opens */
  target: _propTypes["default"].node.isRequired,

  /** Controlls whether popper is open */
  open: _propTypes["default"].bool.isRequired,

  /** Callback to request parent to update `open` prop to false */
  onRequestClose: _propTypes["default"].func,

  /** Placement of popper in relation to target */
  placement: _propTypes["default"].oneOf(['top', 'top-end', 'top-start', 'right', 'right-end', 'right-start', 'bottom', 'bottom-end', 'bottom-start', 'left', 'left-end', 'left-start']),

  /** Bool flag to determine whether to show/hide the arrow */
  hideArrow: _propTypes["default"].bool,

  /** Custom styled popper component to use instead of the default */
  StyledPopper: _propTypes["default"].func,

  /** Props to be passed to the popper element */
  popperProps: _propTypes["default"].object,
  // eslint-disable-line

  /** Applies appropriate height/width rules if popover is uncontained */
  uncontained: _propTypes["default"].bool,

  /** Allows disabling fade in/out transitions */
  disableTransitions: _propTypes["default"].bool
};
Popover.defaultProps = {
  onRequestClose: function onRequestClose() {},
  children: null,
  placement: 'bottom',
  hideArrow: false,
  StyledPopper: null,
  popperProps: {},
  uncontained: false,
  disableTransitions: false
};
var PopoverWithClickOutside = (0, _reactOnclickoutside["default"])(Popover);

var _default = (0, _withStyles["default"])(_styles["default"])(PopoverWithClickOutside);

exports["default"] = _default;